<div class="dialog-edit-team dialog">

    <h2 mat-dialog-title class="modal-header">
       {{info}} 
    </h2>

    <div mat-dialog-content class="modal-content">
        {{content}}
    </div>


    
    <div ma-dialog-footer>

    </div>
</div>